import { Component, Prop, State, h, Host } from '@stencil/core';

@Component({
  tag: 'dda-tabs',
  styleUrls: ['dda-tabs.css', '../../global/global.css'],
  shadow: false,
})
export class DdaTabs {
  @Prop() type: 'text' | 'text-icon' = 'text'; // Default to text type
  @Prop() hover_style: 'dda-tab-default' | 'dda-tab-filed' | 'dda-tab-underline' |'dda-tab-underline-filled' = 'dda-tab-default'; // Default to light background hover style
  @Prop() border_bottom: boolean = false; // Default to no border-bottom
  @Prop() custom_class?: string = ''; 
  @Prop() component_mode?: string; 
  @Prop() button_id?: string;
  @Prop() aria_label: string;

  @State() active_tab: number = 0;

  tabs = [
    { title: 'Tab 1', icon: 'fa-face-smile' },
    { title: 'Tab 2', icon: 'fa-face-smile' },
    { title: 'Tab 3', icon: 'fa-face-smile' },
  ];

  setActiveTab(index: number) {
    this.active_tab = index;
  }

  render() {
    return (
      <Host>
        <div class={`dda-tabs-container ${this.hover_style} ${this.custom_class} ${this.component_mode}`}>
          {this.tabs.map((tab, index) => (
            <button id={this.button_id} aria-label={this.aria_label} type="button"
              class={`dda-tab-item  ${this.active_tab === index ? 'active' : ''}`}
              onClick={() => this.setActiveTab(index)}
            >
              {this.type === 'text-icon' && <i class={`fa-regular ${tab.icon}`}></i>}
              <span>{tab.title}</span>
            </button>
          ))}
        </div>
      </Host>
    );
  }
}